import React, { useMemo, useState } from "react";
import RouteConfigHandler from "../../templates/route-config-handler";
import WebPageMainRegion, {
  PAGE_HEADING_VARIANTS,
} from "../../templates/WebPageMainRegion";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { Divider, Grid } from "@material-ui/core";
import InvoiceHeaderView from "./templates/invoice-header-view";
import { useParams } from "react-router-dom/cjs/react-router-dom";

import InvoiceView from "./templates/invoice-view";
import PaymentView from "./templates/payment-view";
import PageConfig, { PageContext } from "./config";
import PageDomain from "./domain";
import ContentLoadingView from "./templates/content-loading-view";

import "./style.css";

const { PAYMENT_METHOD_VIEW, CHECKOUT_OPTIONS } = PageConfig;

const activeCheckoutOptions = Object.values(CHECKOUT_OPTIONS).filter(
  (option) => option.activated
);

const PaymentByLinkPage = ({ routeId }) => {
  const { t } = useTranslation();
  const { authProfile } = useSelector((state) => state.application);
  const { id: paymentLinkId } = useParams();
  // TODO: Remove this --> No need now
  const [paymentMethodUI, setPaymentMethodUI] = useState(
    PAYMENT_METHOD_VIEW.PAYMENT_METHOD_SELECTOR
  );
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(
    activeCheckoutOptions[0] ?? {}
  );
  const [secondaryPaymentMethod, setSecondaryPaymentMethod] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [genericPaymentMethods, setGenericPaymentMethods] = useState([]);
  const [paymentLinkData, setPaymentLinkData] = useState({});
  const [submitCount, setSubmitCount] = useState(0);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [currency, setCurrency] = useState("");
  const [shouldApplyPromoCode, setShouldApplyPromoCode] = React.useState(false);

  const heading = isEmpty(authProfile.firstPublishedAt)
    ? t("pricing.payforAd")
    : t("pricing.renewAd");

  React.useEffect(() => {
    PageDomain.initGenericPaymentMethods({ setGenericPaymentMethods });
    PageDomain.initPaymentLinkData({ id: paymentLinkId, setPaymentLinkData });
  }, [paymentLinkId]);

  React.useEffect(() => {
    PageDomain.initPaymentCurrencyByPaymentLinkData({
      paymentLinkData,
      setCurrency,
    });
  }, [paymentLinkData]);

  const didPageBoostrapped = useMemo(() => {
    return !isEmpty(paymentLinkData) && !isEmpty(genericPaymentMethods);
  }, [paymentLinkData, genericPaymentMethods]);

  return (
    <RouteConfigHandler id={routeId}>
      <WebPageMainRegion
        pageHeading={heading}
        headingVaraint={PAGE_HEADING_VARIANTS.OUTSIDE_HEADING}
        contentRootCSSClass="payment-by-link-page"
      >
        <PageContext.Provider
          value={{
            paymentLinkId,
            paymentMethodUI,
            setPaymentMethodUI,
            selectedPaymentMethod,
            setSelectedPaymentMethod,
            genericPaymentMethods,
            setGenericPaymentMethods,
            secondaryPaymentMethod,
            setSecondaryPaymentMethod,
            formErrors,
            setFormErrors,
            submitCount,
            setSubmitCount,
            agreedToTerms,
            setAgreedToTerms,
            paymentLinkData,
            setPaymentLinkData,
            promoCode,
            setPromoCode,
            currency,
            setCurrency,
            shouldApplyPromoCode,
            setShouldApplyPromoCode,
          }}
        >
          {!didPageBoostrapped && <ContentLoadingView />}
          {didPageBoostrapped && (
            <>
              <InvoiceHeaderView />
              <Grid container className="content-root-container">
                <Grid className="page-section">
                  <InvoiceView />
                </Grid>
                <Divider className="section-divider vertical" />
                <Divider className="section-divider horizontal" />
                <Grid className="page-section">
                  <PaymentView />
                </Grid>
              </Grid>
            </>
          )}
        </PageContext.Provider>
      </WebPageMainRegion>
    </RouteConfigHandler>
  );
};

export default PaymentByLinkPage;
